// Define types for native app interfaces
export interface WebkitBridge {
  messageHandlers: {
    rewardsMessageHandler: {
      postMessage: (message: unknown) => void;
    };
  };
}

export interface AndroidBridge {
  sendMessage: (message: string) => void;
}
// Extend Window interface
declare global {
  interface Window {
    webkit?: WebkitBridge;
    Android?: AndroidBridge;
  }
}

// Define Offer type for tracking
export type Offer = {
  id: string;
  attributes: {
    name: string;
    purchase_channel: string[];
    user_reward: {
      type: string;
      value: number;
    };
    website_url?: string;
    expiration_date: string;
  };
};

// Define event types
export type OfferEventType = 'viewOffer' | 'tapOfferActionButton';

/**
 * Tracks an offer event with detailed information
 * @param offer The complete offer object to track
 * @param eventType The type of event ('viewOffer' or 'tapOfferActionButton')
 */
export function trackOfferEvent(offer: Offer, eventType: OfferEventType) {
  const analyticsPayload = {
    event: eventType,
    payload: {
      id: offer.id,
      name: offer.attributes.name,
      purchase_channel: offer.attributes.purchase_channel,
      reward_type: offer.attributes.user_reward.type,
      reward_value: offer.attributes.user_reward.value,
      website_url: offer.attributes.website_url,
      expiration_date: offer.attributes.expiration_date,
      timestamp: new Date().toISOString()
    }
  };

  // Send to iOS
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.rewardsMessageHandler
  ) {
    window.webkit.messageHandlers.rewardsMessageHandler.postMessage(analyticsPayload);
  }

  // Send to Android
  if (window.Android && window.Android.sendMessage) {
    window.Android.sendMessage(JSON.stringify(analyticsPayload));
  }

  console.log(`Sent ${eventType} event:`, analyticsPayload);
}

/**
 * Tracks when an offer is viewed
 * @param offer The complete offer object to track
 */
export function trackOfferViewed(offer: Offer) {
  trackOfferEvent(offer, 'viewOffer');
}

/**
 * Tracks when an offer action button is tapped
 * @param offer The complete offer object to track
 */
export function trackOfferActionTapped(offer: Offer) {
  trackOfferEvent(offer, 'tapOfferActionButton');
}

/**
 * Sends a message to the native app to close the webview
 */
export function closeWebView() {
  // Change the URL with a close parameter that the native app can detect
  window.location.href = 'merchant-rewards://close';
}